import { Module } from '../Module';
import { GetProjectNamesRequest, IGetProjectNamesResult } from '../ServerApi/requests/GetProjectNamesRequest';
import { IProjectName } from '../ServerApi/types/IProject';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class ProjectNames extends Resource<IProjectName> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetProjectNamesRequest,
      (result: IGetProjectNamesResult) => result.projects));
  }

}

Module.instance().service('ProjectNames', ProjectNames);
